let youtubeIframes = [];

window.addEventListener('DOMContentLoaded', function() {
    youtubeIframes = document.getElementsByClassName('youtube-player');
    if(youtubeIframes.length) {
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
}, false);

function onYouTubeIframeAPIReady() {
    const players = [];
    for(let i = 0; i < youtubeIframes.length; i++) {
        players[i] = new YT.Player(youtubeIframes[i].id, {
            events: {
                'onReady': onPlayerReady
            }
        });
    }
}

function onPlayerReady(event) {
    switchVideo(event.target);
    window.addEventListener('scroll', function() {
        switchVideo(event.target);
    }, false);
}

function switchVideo(targetPlayer) {
    const playerPosition = targetPlayer.getIframe().getBoundingClientRect().top + window.pageYOffset;
    const startPosition = window.pageYOffset + window.innerHeight;
    const endPosition = window.pageYOffset;
    if((playerPosition < startPosition) && (playerPosition > endPosition)) {
        targetPlayer.mute();
        targetPlayer.playVideo();
    }
    else {
        targetPlayer.pauseVideo();
    }
}

